<lib-template-process [template]="data.selectedTemplate" [allowSaveAsDocx]="true" [allowSaveAsBase64]="true"
  [allowSaveAsPdf]="true" [backendProcessType]="'PROCESS_USING_PROVIDED_DATA'" [fieldsDataObject]="data.data"
  [groupsDataObject]="data.data" [showActions]="true" (saveMerged)="onSaveMerged($event)"
  (saveTemplate)="onSaveTemplate($event)" (saveAsPDF)="onSaveAsPDF($event)" (processClose)="onProcessFinish($event)">
</lib-template-process>
